import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../../redux/reducers/ModalManager";
import { DeleteJobButton } from "../DeleteJobButton";
import { ReduxState } from "../../../../redux";
import { DownloadModal } from "./DownloadModal";
import { RedoJobButton } from "../RedoJobButton";
import { emailJob, markJobReviewed } from "../../../../docuclipper/api";
import { createAlert } from "../../../../redux/reducers/Alerts";
import TransactionManagerTour from "./TransactionManagerTour";
import { setHelpDrawerOpen } from "../../../../redux/reducers/HelpDrawer";
import { useHasQbo } from "../../../../utils/utils";
import { useIsAdmin } from "../../../../utils/auth";
import { DebugJobButton } from "../DebugJobButton";

export const JobAdminButtons = () => {
  const dispatch = useDispatch();

  const { token } = useSelector((state: ReduxState) => state.Auth);
  const { job, progress } = useSelector((state: ReduxState) => state.JobData);
  const { isAdmin, isSuperLogin } = useIsAdmin();

  if (!job) {
    return null;
  }
  const onEmail = () => {
    emailJob(job.id)
      .then((x) =>
        dispatch(
          createAlert({
            message: "Email sent successfully",
            timeout: 0,
            type: "success",
          })
        )
      )
      .catch((err) => {
        dispatch(
          createAlert({
            message: "Error emailing job",
            timeout: 0,
            type: "error",
          })
        );
      });
  };

  const onMarkReviewed = () => {
    markJobReviewed(job.id)
      .then((x) =>
        dispatch(
          createAlert({
            message: "Job marked as reviewed successfully",
            timeout: 0,
            type: "success",
          })
        )
      )
      .catch((err) => {
        dispatch(
          createAlert({
            message: "Error marking job as reviewed",
            timeout: 0,
            type: "error",
          })
        );
      });
  };

  return (
    <>
      {(isAdmin || isSuperLogin) && (
        <Row className="justify-content-end">
          <RedoJobButton job={job} />
          <DebugJobButton job={job} />
          <Button className="ml-2" variant="link" onClick={onEmail}>
            <FontAwesomeIcon icon="envelope" />
            <span className="ml-1">Email</span>
          </Button>
          <Button className="ml-2" variant="link" onClick={onMarkReviewed}>
            <FontAwesomeIcon icon="check" />
            <span className="ml-1">Mark reviewed</span>
          </Button>
          <DeleteJobButton job={job} />
        </Row>
      )}
    </>
  );
};

export const JobButtons = ({ downloadButton }) => {
  const dispatch = useDispatch();
  const { job, progress } = useSelector((state: ReduxState) => state.JobData);

  const hasQbo = useHasQbo();
  if (!job) {
    return null;
  }

  return (
    <>
      <Row className="justify-content-end">
        <div className="ml-2">
          <DeleteJobButton job={job} />
        </div>
        <div>
          <Button
            // style={{
            //   marginTop: "-0.5rem",
            // }}
            className="ml-2 btn--report-bad-job"
            variant="light"
            onClick={() => {
              // dispatch(openModal("ratings", {}));
              dispatch(setHelpDrawerOpen(true));
            }}
          >
            <FontAwesomeIcon icon="exclamation-triangle" />
            <span className="m-2">Report Issue</span>
          </Button>
        </div>

        <div className="mx-4">{downloadButton && downloadButton()}</div>
      </Row>
    </>
  );
};
